import React, { FC, useEffect, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";

import { useState } from "react";
import { HistoriesOrdersModal } from "./HistoriesOrdersModal";
import HistoriesOrdersSearch from "./HistoriesOrdersSearch";
import HistoriesOrdersTable from "./HistoriesOrdersTable";

const App = ({
  dispatch_info,
  dispatch_danger,
  dispatch_get_histories_orders,
  dispatch_put_markets_exchanges_id_cancel,
}) => {
  const ref = useRef();
  const [t, i18n] = useTranslation();
  const maps = useSelector((state) => state.reduce_get_maps);
  useEffect(() => {
    // document.body.classList.toggle("login-page");
    // document.body.classList.add("color-default");
    // document.body.classList.toggle("color-default");
    // return function cleanup() {
    //   // document.body.classList.toggle("login-page");
    //   document.body.classList.toggle("color-default");
    // };
  }, []);

  const [searchHistoriesOrders, set_searchHistoriesOrders] = useState({
    _search: { page: 1, limit: 10 },
  });

  const [modalHistoriesOrders, set_modalHistoriesOrders] = useState(
    false
  );

  const histories_orders = useSelector(
    (state) => state.reduce_get_histories_orders
  );


 


  const inLoading =
    histories_orders.isLoading || !histories_orders.orders;
  const data_tables = inLoading ? [] : histories_orders.orders;

  const total_count = inLoading ? 0 : histories_orders.count;



  return (
    <>
      {/* <div className="content"> */}
        {/* <div className="info info-horizontal ml-4">
          <div className="description">
            <h4 className="info-title">
              <img
                className="mr-3"
                alt="..."
                src={require("assets/svg/bank-check.svg")}
                width="30px"
              />
              {t("出金承認")}
            </h4>
            <p className="mb-1 ml-5">{t("出金承認を管理します")}</p>
          </div>
        </div> */}
        <HistoriesOrdersSearch
          inLoading={inLoading}
          searchHistoriesOrders={searchHistoriesOrders}
          set_searchHistoriesOrders={set_searchHistoriesOrders}
          dispatch_get={dispatch_get_histories_orders}
          total_count={total_count}
        />
        <HistoriesOrdersTable
          searchHistoriesOrders={searchHistoriesOrders}
          set_searchHistoriesOrders={set_searchHistoriesOrders}
          set_modalHistoriesOrders={set_modalHistoriesOrders}
          dispatch_put_markets_exchanges_id_cancel={
            dispatch_put_markets_exchanges_id_cancel
          }
          data_tables={data_tables}
          inLoading={inLoading}
        />
        <HistoriesOrdersModal
          inLoading={inLoading}
          modal={modalHistoriesOrders}
          set_modal={set_modalHistoriesOrders}
          close_modal={() => {
            // set_searchHistoriesOrders({ limit: 10, page: 1 });
            set_modalHistoriesOrders(false);
          }}
          searchHistoriesOrders={searchHistoriesOrders}
          set_searchHistoriesOrders={set_searchHistoriesOrders}
          searchHistoriesOrders={searchHistoriesOrders}
          // set_searchHistoriesOrders={set_searchHistoriesOrders}
          dispatch_info={dispatch_info}
          dispatch_danger={dispatch_danger}
          dispatch_put_markets_exchanges_id_cancel={
            dispatch_put_markets_exchanges_id_cancel
          }
        />
      {/* </div> */}
    </>
  );
};

export default App;
